import React from 'react';
import { Backpack, Compass, Route } from 'lucide-react';
import { BASECAMP } from '../content';
import { SCENE_IMG } from '../media';
const ICONS = {
  compass: Compass,
  route: Route,
  backpack: Backpack
};
export function Basecamp() {
  return <section id="basecamp" className="bg-background" aria-labelledby="basecamp-heading" data-id="element-10" data-mp="29oh4m171mogp">
      <div className="section-shell py-16 lg:py-20" data-id="element-11" data-mp="24qpb52qr2uae">
        {/* Headline beside the aspen grove: many trunks, one root system. */}
        <div className="grid items-center gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14" data-id="element-12" data-mp="2xdtn5ro9g8vo">
          <div data-id="element-13" data-mp="2xbz12a196aq0">
            <p className="overline" data-id="element-14" data-mp="2seqk2cruccqc">What basecamp gives you</p>
            <h2 id="basecamp-heading" className="mt-5 max-w-2xl font-serif text-h3 lg:text-h2" data-id="element-15" data-mp="2scvw0pl9w4i1">
              We listen first. Then we bring the right people into the room.
            </h2>
          </div>
          <figure className="m-0 overflow-hidden rounded-lg" data-id="element-16" data-mp="1h0uzupm2xds9">
            <img src={SCENE_IMG.aspenGrove} alt="An autumn aspen grove, hundreds of pale trunks sharing one root system" loading="lazy" className="block h-56 w-full object-cover object-center lg:h-72" data-id="element-17" data-mp="1bzfgd1zjvfbz" />
          </figure>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-18" data-mp="qou7596ekm91">
          {BASECAMP.map(card => {
          const Icon = ICONS[card.icon];
          return <article key={card.title} className="rounded-lg border border-border bg-card p-7 lg:p-8" data-id="element-19" data-mp="h0c8oyllir8k">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-secondary text-secondary-foreground" data-id="element-20" data-mp="lqkb6wcuthmd">
                  <Icon size={20} aria-hidden="true" data-id="element-21" data-mp="80p3s2tnr3ar" />
                </span>
                <h3 className="mt-6 font-serif text-h4 leading-snug" data-id="element-22" data-mp="cxpe4pxjis7o">{card.title}</h3>
                <p className="mt-3 text-body-sm leading-body text-muted-foreground" data-id="element-23" data-mp="3u63y7dmxm3sz">{card.body}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}